/**
 * Action name for contact form submit.
 * Must match the action checked during createAssessment.
 * @see https://cloud.google.com/recaptcha/docs/actions
 */
export const CONTACT_RECAPTCHA_ACTION = "submit";
